import axios from 'axios'

// ═══════════════════════════════════════════════════════════════════════════
//  Klien API + penyimpanan sesi
//
//  Token disimpan di localStorage. Untuk alat internal ini itu memadai; yang
//  penting ia dibersihkan SECARA TERPUSAT saat 401, bukan di tiap halaman.
//
//  Kalau tiap halaman menangani 401 sendiri, akan ada halaman yang lupa — dan
//  gejalanya bukan "sesi habis" melainkan daftar kosong tanpa penjelasan.
// ═══════════════════════════════════════════════════════════════════════════

const KUNCI = 'karaoke.sesi'

export type Izin = {
  boleh_kelola_katalog: boolean
  boleh_putus_pengadaan: boolean
  boleh_kelola_user: boolean
}

export type Sesi = {
  token: string
  user: { id: string; nama: string; email: string }
  // Izin per perbuatan, BUKAN satu "role". Nama fieldnya sama persis dengan
  // kolom kr_user dan dengan yang diperiksa server — tiga tempat, satu nama.
  izin: Izin
}

export function bacaSesi(): Sesi | null {
  try {
    const raw = localStorage.getItem(KUNCI)
    if (!raw) return null
    const s = JSON.parse(raw) as Sesi
    // Sesi dari versi SEBELUM izin dipecah menyimpan `boleh_kelola`, bukan
    // `izin`. Membiarkannya lewat membuat s.izin.boleh_kelola_katalog melempar
    // "cannot read properties of undefined" saat render pertama — layar putih
    // total, tanpa satu pun petunjuk bahwa sebabnya sesi lama.
    //
    // Diperlakukan sebagai sesi tidak sah: dibuang, lalu masuk lagi.
    if (!s?.token || !s?.izin) { localStorage.removeItem(KUNCI); return null }
    return s
  } catch {
    // localStorage yang isinya rusak (mis. sisa versi lama) tidak boleh
    // membuat aplikasinya gagal muat sama sekali — dibuang, lalu masuk lagi.
    localStorage.removeItem(KUNCI)
    return null
  }
}

export function simpanSesi(s: Sesi) { localStorage.setItem(KUNCI, JSON.stringify(s)) }
export function hapusSesi() { localStorage.removeItem(KUNCI) }

const api = axios.create({ baseURL: '' })

api.interceptors.request.use((cfg) => {
  const s = bacaSesi()
  if (s?.token) cfg.headers.Authorization = `Bearer ${s.token}`
  return cfg
})

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // 401 = token habis/tidak sah → buang sesi, muat ulang ke halaman masuk.
    //
    // 403 SENGAJA TIDAK ikut: itu berarti "sudah masuk, tapi tidak berhak".
    // Melempar orang keluar saat menekan tombol yang tidak boleh ia tekan
    // terbaca seperti sistem yang rusak — dan ia akan masuk lagi, lalu
    // mencobanya lagi.
    if (err?.response?.status === 401) {
      hapusSesi()
      location.reload()
    }
    return Promise.reject(err)
  },
)

// Pesan galat yang bisa dibaca orang. Axios sendiri menjawab "Request failed
// with status code 500", kalimat yang tidak membantu siapa pun.
export function pesanGalat(e: any, bawaan = 'Terjadi kesalahan'): string {
  return e?.response?.data?.error ?? e?.message ?? bawaan
}

export default api
